<template>
  <div class="container">
      {{message}}
  </div>
</template>

<script>
export default {
    data() {
        return {
            message: 'Please submit an OA request and contact the admin for access.'
        }
    }

}
</script>

<style lang="less" scoped>
    .container {
        overflow: hidden;
        width: 100%;
        height: 90vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #000;
        font-size: 30px;
    }
</style>